import React, { useState, useEffect } from "react";
import { MdCheck, MdDelete, MdEdit } from "react-icons/md";
import ImageItem from "./ImageItem";
import AudioItem from "./AudioItem";
import VideoItem from "./VideoItem";
import TextItem from "./TextItem";
import { Button, IconButton } from "@mui/material";
import AnnotationItem from "./AnnotationItem";

function ItemContainer({
  item,
  applyChanges,
  editing,
  setEditing,
  deleteThis,
  showReorderingArrows,
  canMoveUp,
  canMoveDown,
  shiftUp,
  shiftDown,
  lang,
}) {
  const [tempItem, setTempItem] = useState(item || { content: {}, options: {}, audioClip: {} });
  const [editingThis, setEditingThis] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);

  useEffect(() => {
    setEditing(editingThis);
    if (editingThis) setTempItem(item);
  }, [editingThis]);

  // update the local item whenever the order of items is changed
  useEffect(() => {
    setTempItem(item);
  }, [item]);

  function getItemComponent(item) {
    switch (item.type) {
      case "image":
        return (
          <ImageItem
            item={tempItem}
            setItem={setTempItem}
            editing={editingThis}
            leftPadding={showReorderingArrows}
            lang={lang}
          />
        );
      case "audio":
        return (
          <AudioItem
            item={tempItem}
            setItem={setTempItem}
            editing={editingThis}
            leftPadding={showReorderingArrows}
            index={item.id}
            lang={lang}
          />
        );
      case "video":
        return (
          <VideoItem
            item={tempItem}
            setItem={setTempItem}
            editing={editingThis}
            leftPadding={showReorderingArrows}
            lang={lang}
          />
        );
      case "text":
        return (
          <TextItem
            item={tempItem}
            setItem={setTempItem}
            editing={editingThis}
            leftPadding={showReorderingArrows}
            lang={lang}
          />
        );
      case "annotation":
        return <AnnotationItem editing={editingThis} />;
      default:
        return <div className="FW-content">Error... Unknown content!</div>;
    }
  }

  function cancelEditing() {
    setTempItem(item);
    setEditingThis(false);
  }

  function handleApply() {
    applyChanges(tempItem);
    setEditingThis(false);
  }

  return (
    <div className={`FW-content-container ${editingThis ? "editing" : ""}`} id={item.type}>
      {!editing && (
        <div className={`FW-delete-button ${deleteConfirm ? "confirm" : ""}`}>
          <IconButton color="redButton" onClick={deleteConfirm ? deleteThis : () => setDeleteConfirm(true)}>
            <MdDelete />
          </IconButton>
          <div className="FW-cancel-delete-button">
            <Button size="small" variant="outlined" color="cancelButton" onClick={() => setDeleteConfirm(false)}>
              Cancel
            </Button>
          </div>
        </div>
      )}
      {editingThis === editing && (
        <div className={`FW-edit-button ${editingThis ? "editing" : ""}`}>
          <IconButton color="toolButtonActive" onClick={editingThis ? handleApply : () => setEditingThis((e) => !e)}>
            {editingThis ? <MdCheck /> : <MdEdit />}
          </IconButton>
          <div className="FW-cancel-edit-button">
            <Button size="small" variant="outlined" color="cancelButton" onClick={cancelEditing}>
              Cancel
            </Button>
          </div>
        </div>
      )}
      {getItemComponent(item)}
      {showReorderingArrows && (
        <div className="FW-reordering-arrows-container">
          <div className="FW-shift-order-button" id="up">
            <button disabled={!canMoveUp} onClick={() => shiftUp(item.id)}>
              <svg viewBox="0 -4 24 24" opacity={canMoveUp ? "1" : "0.25"} stroke="none">
                <path d="M12 18a1.51 1.51 0 0 1-1.06-.44l-9-9a1.5 1.5 0 0 1-.33-1.63A1.51 1.51 0 0 1 3 6h18a1.51 1.51 0 0 1 1.39.93 1.5 1.5 0 0 1-.33 1.63l-9 9A1.51 1.51 0 0 1 12 18Z" />
              </svg>
            </button>
          </div>
          <div className="FW-shift-order-button" id="down">
            <button disabled={!canMoveDown} onClick={() => shiftDown(item.id)}>
              <svg viewBox="0 4 24 24" opacity={canMoveDown ? "1" : "0.25"} stroke="none">
                <path d="M12 18a1.51 1.51 0 0 1-1.06-.44l-9-9a1.5 1.5 0 0 1-.33-1.63A1.51 1.51 0 0 1 3 6h18a1.51 1.51 0 0 1 1.39.93 1.5 1.5 0 0 1-.33 1.63l-9 9A1.51 1.51 0 0 1 12 18Z" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default ItemContainer;
